import { render, staticRenderFns } from "./view3d.vue?vue&type=template&id=8cbfbea0&scoped=true"
import script from "./view3d.vue?vue&type=script&lang=js"
export * from "./view3d.vue?vue&type=script&lang=js"
import style0 from "./view3d.vue?vue&type=style&index=0&id=8cbfbea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbfbea0",
  null
  
)

export default component.exports